import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBGRzbfYz5iDQRL0ZztK0YAfJczlZSSw80",
  authDomain: "annual-client-review.firebaseapp.com",
  projectId: "annual-client-review",
  storageBucket: "annual-client-review.firebasestorage.app",
  messagingSenderId: "573205242862",
  appId: "1:573205242862:web:49eb514838acc69b1ea4ff",
  measurementId: "G-9RL2TRL92L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let analytics = null;

isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

export { analytics, logEvent };